import moment from 'moment';
import PropTypes from 'prop-types';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';

import Typography from '../Typography/Typography';
import styles from './PublishDate.module.scss';

const PublishDate = ({ publishDate, ...props }) => {
    return (
        <ContentContainer>
            <div className={styles['publish-date']} {...props}>
                {publishDate && (
                    <Typography
                        tag="span"
                        variant="t2"
                        content={`Published: ${moment(publishDate).format('MMMM DD, YYYY')}`}
                        className={styles['publish-date__text']}
                    />
                )}
            </div>
        </ContentContainer>
    );
};

PublishDate.propTypes = {
    /**
     * Content of the Text
     */
    publishDate: PropTypes.node,
};

export default PublishDate;
